<template>
  <v-card class="card" color="primary">
    <v-card-text class="d-flex justify-space-between">
      <v-container>
        <v-row v-if="perfil === PERFILES['Administrador IPH+'] || perfil === PERFILES['Policia']">
          <v-col align="right">
            <TextButton @click="openAgregarEstudio"> AGREGAR ESTUDIO </TextButton>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <estudios-table :estudios="estudios" :loading="loading" @edit="editarEstudio" />
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<style scoped>
/* Estilos modernos para Estudios */
.card {
  background: rgba(26, 46, 36, 0.6) !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(0, 210, 160, 0.2);
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
  animation: fadeInUp 0.6s ease-out;
}

.card:hover {
  transform: translateY(-2px);
  border-color: rgba(0, 210, 160, 0.4);
  box-shadow: 0 12px 48px rgba(0, 210, 160, 0.3);
}

/* Card title y text */
::v-deep .v-card-title {
  background: rgba(0, 210, 160, 0.08);
  border-bottom: 1px solid rgba(0, 210, 160, 0.2);
  padding: 24px !important;
  color: #e0e0e0 !important;
  font-weight: 700 !important;
}

::v-deep .v-card-text {
  padding: 32px 24px !important;
  color: #e0e0e0 !important;
}

/* Animación */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { DIALOG_TYPES } from '@/plugins/dialog-types'
import { PERFILES } from '@/perfiles.js'
import TextButton from '../../../base/TextButton.vue'
import EstudiosTable from '../../estudios/EstudiosTable.vue'

export default {
  components: {
    TextButton,
    EstudiosTable,
  },
  data() {
    return {
      PERFILES,
      DIALOG_TYPES,
      loading: false,
    }
  },
  computed: {
    ...mapGetters('personal', {
      personal: 'getPersonalSingle',
    }),
    ...mapGetters({
      perfil: 'getPerfil',
    }),
    ...mapGetters('estudio', {
      estudiosAll: 'getEstudios',
    }),
    idPersonal() {
      return this.personal?.idPersonal
    },
    estudios() {
      return this.estudiosAll.filter((e) => e.fk_idPersonal == this.idPersonal)
    },
  },
  methods: {
    ...mapMutations('dialog', ['SET_DIALOG']),
    ...mapMutations('estudio', ['SET_SELECTED_ESTUDIO']),
    ...mapActions('estudio', ['fetchEstudiosByPersonal']),

    openAgregarEstudio() {
      this.SET_DIALOG({
        ...DIALOG_TYPES.AGREGAR_ESTUDIO,
        props: {
          id: this.idPersonal,
        },
      })
    },

    editarEstudio(estudio) {
      this.SET_SELECTED_ESTUDIO(estudio)
      this.SET_DIALOG(DIALOG_TYPES.EDITAR_ESTUDIO)
    },
  },
  async mounted() {
    if (this.idPersonal) {
      this.loading = true
      await this.fetchEstudiosByPersonal(this.idPersonal)
      this.loading = false
    }
  },
}
</script>
